export default function ServicesHero() {
  return (
    <div className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: 'url(https://i.imgur.com/KYV9gqq.jpeg)',
          objectPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20 text-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-3 sm:mb-4 lg:mb-6 font-poppins leading-tight px-4">
          Quality Roofing Services<br className="hidden sm:block" /> at Fair Prices
        </h1>
        <p className="text-base sm:text-lg lg:text-xl text-white/90 max-w-3xl mx-auto mb-5 sm:mb-6 lg:mb-8 px-4 leading-relaxed">
          Get matched with vetted pros who deliver exceptional work without the middleman markup. From replacements to repairs, we connect you with contractors who put quality and fairness first.
        </p>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4 px-4 max-w-md sm:max-w-none mx-auto">
          <a
            href="/contact"
            className="bg-[#2B5BA6] text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg font-semibold hover:bg-[#234a8a] transition-colors whitespace-nowrap cursor-pointer text-center min-h-[52px] flex items-center justify-center text-base sm:text-lg"
          >
            Get Instant Estimate
          </a>
          <a
            href="tel:+14793366968"
            className="inline-flex items-center gap-3 px-8 py-4 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors cursor-pointer text-lg font-semibold"
          >
            <i className="ri-phone-line text-2xl"></i>
            Call (479) 336-6968
          </a>
        </div>
      </div>
    </div>
  );
}